module.exports = __webpack_public_path__ + "static/media/dianhua1.ccff4f1d.jpeg";